<script setup>
	let version = 'version ' + __APP_VERSION__
	if(import.meta.env.VITE_APP_ENV && import.meta.env.VITE_APP_ENV === 'production') {
        version = '';
	}
</script>

<template>
	<footer>
		<!-- <div class="footer1">
			<div><router-link class="link-item" :to="{ name: 'ContactView', hash: '#1' }" tabindex="0">Permissions</router-link></div>
			<div><a class="link-item" href="https://www.ncses.nsf.gov/browse-library?dataCollection=Science%20and%20Engineering%20Indicators" rel="noopener" tabindex="0">Prior Releases</a></div>
			<div><router-link class="link-item" :to="{ name: 'ContactView', hash: '#0' }" tabindex="0">Contact Us</router-link></div>
			<div><a class="link-item" href="https://ncses.nsf.gov/indicators/about" rel="noopener" tabindex="0">About S&amp;E Indicators</a></div>
		</div> -->
		<div class="footer2">
			<div class="links">
				<div><a class="link-item" href="https://www.nsf.gov/policies/" rel="noopener" tabindex="0">Website Policies</a></div>|
				<div><a class="link-item" href="https://www.nsf.gov/about/performance/" rel="noopener" tabindex="0">Budget and Performance</a></div>|
				<div><a class="link-item" href="https://www.nsf.gov/oig/" rel="noopener" tabindex="0">Inspector General</a></div>|
				<div><a class="link-item" href="https://www.nsf.gov/policies/privacy.jsp" rel="noopener" tabindex="0">Privacy</a></div>|
				<div><a class="link-item" href="https://www.nsf.gov/policies/foia" rel="noopener" tabindex="0">FOIA</a></div>|	
				<div><a class="link-item" href="https://www.nsf.gov/od/oecr/nofearact_notice.jsp" rel="noopener" tabindex="0">No FEAR Act</a></div>|
				<div><a class="link-item" href="https://www.usa.gov/" rel="noopener" tabindex="0">USA.gov</a></div>|
				<div><a class="link-item" href="https://ncses.nsf.gov/accessibility" rel="noopener" tabindex="0">Accessibility</a></div>|
				<div><a class="link-item" href="https://www.nsf.gov/policies/nsf_plain_language.jsp" rel="noopener" tabindex="0">Plain Language</a></div>|
				<div><a class="link-item" href="https://www.research.gov/" rel="noopener" tabindex="0">Research.gov</a></div>
				
				<div><span class="version">{{version}}</span></div>
			</div>
			<div class="address">
				National Center for Science and Engineering Statistics<br>
				Randolph Building, 401 Dulany Street, Alexandria, VA 22314<br>
				Tel: (703) 292-8780 FIRS: (800) 877-8339 TDD: (800) 281-8749				
			</div>
		</div>
	</footer>
</template>

<style scoped>
.footer1 {
	display: flex;
	width: 100%;
	/* max-width: 85rem; */ /* 1360px;*/
	padding: var(--spacing-xl, 1.5rem);
	background: var(--surface-footer-color-Grey, #DBDBDB);

	color: var(--text-Primary, #2C2C2C);
	text-align: center;
	font-variant-numeric: lining-nums proportional-nums;
	column-gap: var(--spacing-xl, 1.5rem);

	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-H6, 1.25rem);
	font-weight: 500;
	line-height: var(--font-line-height-H6, 1.75rem); /* 140% */	
}

.footer2 {
	display: flex;
	width: 100%;
	padding: 0 var(--spacing-xl);
	align-items: flex-start;
	column-gap: var(--spacing-lg, 1rem);
	gap: var(--spacing-lg, 1rem);
	align-self: stretch;
	background-color: var(--surface-color-Secondary);
}

.links {
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	column-gap: var(--spacing-lg, 1rem);
	row-gap: 0.625rem;
}

.link-item {
	color: var(--text-Primary, #2C2C2C);
	text-decoration: none;
}
.link-item:hover {
	text-decoration: underline;
	color: var(--brand-color-ActiveBlue);
}

.address {
	color: var(--text-Primary, #2C2C2C);
	font-variant-numeric: lining-nums proportional-nums;
	font-feature-settings: 'liga' off, 'clig' off;

	/* Medium/Base */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 16px);
	font-style: normal;
	font-weight: 500;
	line-height: var(--font-line-height-Base, 24px); /* 150% */
	min-width: 29.375rem;
}

/* 840px */
@media only screen and (max-width: 52.5rem) {
  .footer2{
    display: block;
  }
  .links {
	row-gap:unset;
  }
  .address{
    padding-top: var(--spacing-xl, 1.5rem);
	min-width: unset;
  } 
}
</style>